import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button,  ThemeProviderV2} from '@blueprint/ui';
import { useModal } from "react-modal-hook";

import bankAccountApi, { useBankAccountById } from "../../../api/bankAccount";
import { Loader, toast } from "../../../common/components/core";
import { useAuthErrorHandlerCreator } from "../../../common/hooks";
import { useGeneralErrorHandlerCreator } from "../../../common/hooks/useGeneralErrorHandler";
import {
    GenericError,
    composeErrorHandlers,
} from "../../../utils/errorHandling";


type DeactivateHandler = {
    isSubmitting: boolean;
    handler: (
        name: string,
    ) => void;
};

const useDeactivateHandler = (accountId: string): DeactivateHandler => {
    const [isSubmitting, setSubmitting] = useState(false);
    const [name, setName] = useState<string>("");
    const onAuthError = useAuthErrorHandlerCreator();
    const useGeneralError = useGeneralErrorHandlerCreator();
    const { mutate } = useBankAccountById(accountId);

    const [show, hide] = useModal(() => {
        const confirm = async () => {
            setSubmitting(true);
            try {
                const res = await bankAccountApi.deactivate(accountId);
                mutate(res)
                toast("Account Deactivated");
            } catch (e) {
                composeErrorHandlers(
                    onAuthError,
                    useGeneralError,
                )(e as GenericError);
            }
            hide();
            setSubmitting(false);
        };

        return (
            <ThemeProviderV2>
            <Modal show onHide={hide} backdrop="static" centered>
                <Loader overlay isLoading={isSubmitting}>
                    <Modal.Header>
                        <h2 className="mb-0">
                            Deactivate
                        </h2>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{`Are you sure you want to deactivate account “${name}”?`}</p>
                    </Modal.Body>

                    <Modal.Footer className="d-flex justify-content-between px-3">
                        <Button variant="light.tertiary" onClick={hide}>
                            Cancel
                        </Button>
                        <Button variant="light.primary" onClick={confirm}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Loader>
            </Modal>
            </ThemeProviderV2>
        );
    }, [accountId, mutate, isSubmitting, name, onAuthError]);

    return {
        isSubmitting,
        handler: (name) => {
            setName(name);
            show();
        },
    };
};

export default useDeactivateHandler;
